import React from "react";
import { Card, NumField, inr, unitPrice } from "./PricingUi";

const Usage = ({ rows }) => (
  <div className="mt-5 rounded-2xl border border-slate-200 overflow-x-auto" data-testid="pricing-usage-table">
    <table className="w-full text-sm">
      <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
        <tr>{["Model", "Builds (30 days)", "Avg. input tokens", "Avg. output tokens"].map((h) => <th key={h} className="px-4 py-2.5 font-medium whitespace-nowrap">{h}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-slate-200 text-slate-600">
        {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-4 text-center text-slate-400">Token usage appears here after new builds.</td></tr>}
        {rows.map((r) => (
          <tr key={r.model}><td className="px-4 py-2.5">{r.label}</td><td className="px-4 py-2.5 font-mono">{r.builds}</td>
            <td className="px-4 py-2.5 font-mono">{r.avg_input_tokens.toLocaleString()}</td><td className="px-4 py-2.5 font-mono">{r.avg_output_tokens.toLocaleString()}</td></tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const BuildCreditsCard = ({ p, set, models, usage }) => {
  const unit = unitPrice(p.base_cost_inr, p.markup_pct);
  const setModel = (id, v) => set({ model_credits: { ...p.model_credits, [id]: v } });
  return (
    <Card title="Credits per build" testid="pricing-build-card"
      desc="Bigger models use more of your Emergent balance, so charge more credits for them. Use the token usage below to fine-tune.">
      <div className="grid sm:grid-cols-3 gap-4">
        {models.map((m) => (
          <NumField key={m.id} label={m.label} suffix="credits" min={1} value={p.model_credits[m.id]} onChange={(v) => setModel(m.id, v)}
            testid={`pricing-model-${m.id}`} hint={`Users pay ${inr(unit * Number(p.model_credits[m.id] || 0))} per message`} />
        ))}
        <NumField label="Plan first" suffix="credits" value={p.plan_credits} onChange={(v) => set({ plan_credits: v })} testid="pricing-plan-credits" />
        <NumField label="Each AI image" suffix="credits" value={p.image_credits} onChange={(v) => set({ image_credits: v })} testid="pricing-image-credits" />
        <NumField label="Custom domain auto-connect" suffix="credits" value={p.domain_credits} onChange={(v) => set({ domain_credits: v })} testid="pricing-domain-credits"
          hint={`Taken once, when a customer's domain goes live · ${inr(unit * Number(p.domain_credits || 0))}`} />
        <NumField label="Custom domain monthly" suffix="credits" value={p.domain_monthly_credits} onChange={(v) => set({ domain_monthly_credits: v })} testid="pricing-domain-monthly-credits"
          hint={`Taken at go-live, then on the 1st of every month while live · ${inr(unit * Number(p.domain_monthly_credits || 0))}/month`} />
        <NumField label="Low balance prompt below" suffix="credits" value={p.low_balance_credits} onChange={(v) => set({ low_balance_credits: v })} testid="pricing-low-balance-credits"
          hint="Customers see a 'running low, top up now' bar under this · 0 turns it off" />
      </div>
      <Usage rows={usage} />
    </Card>
  );
};

export default BuildCreditsCard;
